module.exports = __webpack_public_path__ + "img/excel.ffd2b453.svg";